import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useStyles } from './FormInfoGeneralStyle'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../../redux/actions/user'
import TabNavigation from '../../TabNavigation/TabNavigation'
import FilePicker from '../FilePicker/FilePicker'

//Material UI
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextArea from '../../TextArea/TextArea'
import MenuItem from '@material-ui/core/MenuItem'
import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'

export default function FormInfoGeneral(props) {

  const dispatch = useDispatch()
  const classes = useStyles()
  const { formClass, defaultValues, refresh, centres, comites, id, nextTab, previousTab } = props
  const { register, handleSubmit } = useForm()
  const { enqueueSnackbar } = useSnackbar()
  const [handicape, setHandicape] = useState(defaultValues?.handicape ? true : false)
  const [etudiant, setEtudiant] = useState(defaultValues?.etudiant ? true : false)
  const [centre, setCentre] = useState(defaultValues?.centre ?? '')
  const [comite, setComite] = useState(defaultValues?.comite ?? '')
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [tooltipOpenEtu, setTooltipOpenEtu] = useState(false)
  const [justificatif, setJustificatif] = useState(defaultValues.justificatif_handicap ?? '')
  const [justificatif_etudiant, setJustificatif_etudiant] = useState(defaultValues.justificatif_etudiant ?? '')

  
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  async function save(data, e) {
    data = { ...data, category: 4, centre, comite, justificatif, justificatif_etudiant }
    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
    else if (action === 'next') nextTab()
  }


  return (
    <form onSubmit={handleSubmit(save)}>
      <div className={formClass}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          
          <FormControlLabel
            className={classes.switch}
            control={<Switch
              color="primary"
              onChange={(e) => setHandicape(e.target.checked)}
              checked={handicape}
              inputProps={{ ref: register, name: 'handicape' }}
            />}
            label="Situation de handicap"
            labelPlacement="start"
          />
          <Tooltip open={tooltipOpen} placement="right" arrow={true} title="Vous devez fournir une carte mobilité inclusion ou une carte d’invalidité MDPH pour bénéficier des tarifs pour personnes en situation de handicap.">
            <InfoIcon style={{ marginLeft: '16px', fontSize: '24px', cursor: 'pointer' }} color="primary" onClick={() => setTooltipOpen(!tooltipOpen)}/>
          </Tooltip>

        </div>
        {handicape && (
          <div style={{ marginBottom: 4 }} >
            <FilePicker
              inputLabel="Justificatif (carte mobilité inclusion ou carte d’invalidité MDPH)"
              fileDownloadName="Justificatif situation de handicap"
              required
              defaultValue={defaultValues.justificatif_handicap}
              onChange={(file) => setJustificatif(file)}
            />
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center' }}>
          
          <FormControlLabel
            className={classes.switch}
            control={<Switch
              color="primary"
              onChange={(e) => setEtudiant(e.target.checked)}
              checked={etudiant}
              inputProps={{ ref: register, name: 'etudiant' }}
            />}
            label="Étudiant"
            labelPlacement="start"
          />
          <Tooltip open={tooltipOpenEtu} placement="right" arrow={true} title="Vous devez fournir une carte étudiant ou un certificat de scolarité d’un établissement scolaire situé à Nice pour bénéficier des tarifs étudiant.">
            <InfoIcon style={{ marginLeft: '16px', fontSize: '24px', cursor: 'pointer' }} color="primary" onClick={() => setTooltipOpenEtu(!tooltipOpenEtu)}/>
          </Tooltip>

        </div>
        {etudiant && (
          <div style={{ marginBottom: 4 }} >
            <FilePicker
              inputLabel="Justificatif (carte étudiant ou certificat de scolarité)"
              fileDownloadName="Justificatif étudiant"
              required
              defaultValue={defaultValues.justificatif_etudiant}
              onChange={(file) => setJustificatif_etudiant(file)}
            />
          </div>
        )}

        <TextField
          SelectProps={{ native: false, ref: register, defaultValue: defaultValues?.centre }}
          select
          label="Centre"
          variant="outlined"
          margin="dense"
          required
          value={centre}
          onChange={(e) => setCentre(e.target.value)}
        >
          {centres.map((c, i) => (<MenuItem value={c.id} key={i}>{c.libelle} </MenuItem>))}
        </TextField>

        <TextArea register={register} defaultValue={defaultValues?.commentaires} />

      </div>

      <TabNavigation save previous next/>
    </form>
  )
}